import { defineNuxtPlugin, useHead } from '#app'
import extensions from 'virtual:extension-registry'

export default defineNuxtPlugin(() => {
  for (const ext of extensions) {
    let extension = ext.module.default || ext.module
    if (typeof extension === 'function') {
      extension = extension()
    }
    if (extension.getHead && ext.headClientOnly) {
      useHead(extension.getHead(ext.config))
    }
  }
})
